module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ViewPackageView.js"));
	}, "ViewPackageView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ViewPackageView!./src/pages/Register/ViewPackage/ViewPackageView.js
// module id = 828
// module chunks = 438